import { LOANREQUEST_BUCKETS } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = unknown;

export const schemaUserResolver_GetAdvisersByBuckets = z.record(
    z.nativeEnum(LOANREQUEST_BUCKETS),
    z.array(
        UsersTableDefinitionZod.pick({
            assignable: true,
            buckets: true,
            deactivated: true,
            firstName: true,
            id: true,
            lastName: true,
            role: true,
            state: true,
        }).merge(
            z.object({
                locked: z.boolean(),
            }),
        ),
    ),
);

export type SchemaUserResolver_GetAdvisersByBuckets = z.infer<typeof schemaUserResolver_GetAdvisersByBuckets>;

export type UserResolver_GetAdvisersByBuckets = Resolver<Arguments, SchemaUserResolver_GetAdvisersByBuckets>;
